import { findAll, find } from '../utils/dom'

function pad(n) {
	return String(n).padStart(2, '0')
}

function nextOccurrenceOfHour(hour) {
	const target = new Date()
	target.setSeconds(0, 0)
	target.setMinutes(0)
	target.setHours(hour)
	if (target <= new Date()) {
		target.setDate(target.getDate() + 1)
	}
	return target
}

export default function Countdown() {
	return findAll('[js-countdown]')?.map((el) => {
		const props = JSON.parse(el.getAttribute('js-props') || '{}')

		const targetDate = props.nextHour != null ? nextOccurrenceOfHour(props.nextHour) : new Date(props.targetDate)

		find('.countdown-widget__close', el)?.addEventListener('click', () => {
			el.classList.add('is-hidden')
			console.log('')
		})

		const tick = () => {
			const diff = targetDate - Date.now()

			if (diff <= 0) {
				el.classList.add('is-ended')
				clearInterval(interval)
				return
			}

			const hours = Math.floor(diff / 3600000)
			const minutes = Math.floor((diff % 3600000) / 60000)
			const seconds = Math.floor((diff % 60000) / 1000)

			const map = { hours, minutes, seconds }
			for (const [unit, value] of Object.entries(map)) {
				const span = find(`[data-unit="${unit}"]`, el)
				if (span) span.textContent = pad(value)
			}
		}

		tick()
		const interval = setInterval(tick, 1000)

		return { el, interval }
	})
}
